<script setup>
import { computed } from 'vue';

const $props = defineProps({
    src: String,
    text: String,
    size: {
        type: String,
        default: '100px'
    }
});

const textInitial = computed(() => $props.text ? $props.text[0].toUpperCase() : 'X');
</script>

<template>
    <div class="base-avatar">
        <template v-if="src">
            <q-avatar :size="size" color="white" rounded>
                <img :src="src" :alt="`Logo for ${text}`"/>
            </q-avatar>
        </template>
        <template v-else-if="text">
            <q-avatar :size="size" color="white" text-color="primary" rounded>
                <span class="text-weight-bold">{{ textInitial }}</span>
            </q-avatar>
        </template>
        <template v-else>
            <q-avatar :size="size" color="white" text-color="primary" rounded>
                <span class="text-weight-bold">X</span>
            </q-avatar>
        </template>
    </div>
</template>

<style lang="scss">
.base-avatar .q-avatar .q-avatar__content > img {
    aspect-ratio: 1/1;
    height: 100%;
    object-fit: contain;
    width: 100%;
}
</style>
